<template>
  <nav id="sidebar" v-if="!this.$store.state.onMobileTablet" class="sidebar-wrapper sidebar-wrapper-mini">
    <div class="sidebar-content">
      <div class="sidebar-header">
        <div class="profile-wrap">
          
          <div class="user-pic">
            <img
              class="img-responsive img-rounded"
              v-if="this.$store.state.user.profileImage"
              :src="this.$store.state.user.profileImage"
              alt="User picture"
            />
            <img
              class="img-responsive img-rounded"
              v-if="!this.$store.state.user.profileImage"
              src="../../assets/user.jpg"
              alt="User picture"
            />
          </div>
          <div class="user-info">
            <span class="user-name">{{ name }}</span>
            <span class="user-role">{{ organization }}</span>
          </div>
        </div>
        <a class="cursor-pointer signout-link notForMobile" @click="userSignOut"
          ><i class="fas fa-sign-out-alt"></i
        ></a>
      </div>
      <div v-if="this.$store.state.onMobileTablet" class="toggle-button-cover">
          <div class="button-cover">
            <div class="button r" id="sideBarSwitch">
              <input @click="openSideBar" id="switch" type="checkbox" class="checkbox">
              <div class="knobs"></div>
              <div class="layer"></div>
            </div>
          </div>
      </div>
      <div class="navbar" role="navigation">
        <ul class="navbar-nav">
          <li class="nav-item dropdown notForMobile">
            <a
              class="nav-link dropdown-toggle"
              id="dropdowna"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/user.svg"
              /></span>
              <span class="nav-menu-text">User Profile</span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdowna">
              <li class="dropdown-item dropdown">
                <!-- <a
                  class="dropdown-toggle"
                  id="company-dropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Company
                </a> -->
                    <router-link to="/newprofile/company/company-info"> Company </router-link>
                <!-- <ul class="dropdown-menu" aria-labelledby="company-dropdown">
                  <li class="dropdown-item">
                    <router-link to="/profile"> Owner Info </router-link>
                  </li>
                  <li class="dropdown-item">
                    <router-link to="/newprofile/company/plans">
                      Plans
                    </router-link>
                  </li>

                  <li class="dropdown-item">
                    <router-link to="/newprofile/company/billing">
                      Billing
                    </router-link>
                  </li>
                  <li class="dropdown-item">
                    <router-link to="/manage-users"> Users </router-link>
                  </li>
                  <li class="dropdown-item">
                    <router-link to="/newprofile/company/company-info">
                      Company Info
                    </router-link>
                  </li>
                </ul> -->
              </li>
              <li class="dropdown-item dropdown">
                <!-- <a
                  class="dropdown-toggle"
                  id="user-settings-dropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  User Info
                </a> -->
                    <router-link to="/profile"> User Info </router-link>
                <!-- <ul class="dropdown-menu" aria-labelledby="user-settings-dropdown">
                  <li class="dropdown-item">
                    <router-link to="/user-email"> Email </router-link>
                  </li>
                  <li class="dropdown-item">
                    <router-link to="/user-security"> Security </router-link>
                  </li>
                </ul> -->
              </li>
            </ul>
          </li>
          <li class="nav-item notForMobile"
             v-if="$store.state.user.role=='admin'">
                  <router-link to="/administration">
                    <span class="nav-menu-icon"
                      ><img src="../../assets/icons/settings.svg"
                    /></span>
                    <span class="nav-menu-text">Administration </span>
                  </router-link>
              </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="dropdown2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/projects.svg"
              /></span>
              <span class="nav-menu-text">Projects</span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdown2">
              <li class="dropdown-item">
                <router-link to="/newprofile/add-story/step-1">
                  Add Project
                </router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/newprofile/projects">
                  Projects Gallery
                </router-link>
              </li>
              <li
                class="dropdown-item dropdown"
                v-show="this.$store.state.selectedStoryId.hasOwnProperty('id')"
              >
                <a
                  class="dropdown-toggle"
                  id="selected-project-dropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <template
                    v-if="
                      this.$store.state.selectedStoryId.hasOwnProperty('title')
                    "
                  >
                    {{
                      this.$store.state.selectedStoryId.title.substring(0, 10)
                    }}
                    Dashboard
                  </template>
                </a>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="selected-project-dropdown"
                >
                  <li class="dropdown-item">
                    <router-link to="/mainStoryView">
                      Decision Tree
                    </router-link>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('universal')">Universal Rule</a>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('overlay')">Overlay</a>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('settings')">Settings (Setup)</a>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('assets')">Assets</a>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('conversation')">Conversation</a>
                  </li>
                  <li class="dropdown-item">
                    <a @click="goTo('moodboard')">Moodboard</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="nav-item notForMobile" v-if="$store.state.user.role=='admin' || $store.state.user.role=='developer'">
            <router-link to="/assets">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/assets.svg"
              /></span>
              <span class="nav-menu-text">Assets</span>
            </router-link>
          </li>
          <li class="nav-item notForMobile" v-if="$store.state.user.role=='admin' || $store.state.user.role=='developer'">
            <router-link to="/userclass">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/api.svg"
              /></span>
              <span class="nav-menu-text">API calls</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/abxr-market">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/abxr_market.svg"
              /></span>
              <span class="nav-menu-text">ABXR Market</span>
            </router-link>
          </li>
          <li class="nav-item"
          v-if="$store.state.user.role=='admin' || $store.state.user.role=='developer'" >
            <!-- <router-link to="/support"> -->
            <a href="https://form.asana.com/?k=sRCquzOsrD80OLXxgsgw7w&d=1132933429989814" target="_">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/support.svg"
              /></span>
              <span class="nav-menu-text">Support</span>
            </a>
            <!-- </router-link> -->
          </li>
          <li class="nav-item ">
            <router-link to="/legal">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/legal.svg"
              /></span>
              <span class="nav-menu-text">Legal</span>
            </router-link>
          </li>
          <li class="nav-item ">
            <router-link to="/updates">
              <span class="nav-menu-icon"
                ><img src="../../assets/icons/update.svg"
              /></span>
              <span class="nav-menu-text">Updates</span>
            </router-link>
          </li>
          <li class="nav-item logout" @click="userSignOut">
            <a >
              <span class="nav-menu-icon"
                ><i class="fas fa-sign-out-alt"></i
              ></span>
              <span class="nav-menu-text">Log out</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import $ from "jquery";
import { db } from "../../firebaseDB";

export default {
  data() {
    return {
      name: "",
      organization: "",
      profileImage: "",
      menu: {},
    };
  },
  mounted() {
    if (this.$store.state.user.hasOwnProperty("id")) {
      let _this = this;
      let tRef = db.ref().child("users/" + this.$store.state.user.id);
      tRef.once("value").then((snapshot) => {
        let cur = snapshot.val();
        let payload = {};
        payload.id = _this.$store.state.user.id;
        payload.email = _this.$store.state.user.email;
        _this.name = "John Smith";
        if (cur && cur.hasOwnProperty("firstName") && cur.firstName) {
          payload.firstName = cur.firstName;
          _this.name = payload.firstName;
        }
        if (cur && cur.hasOwnProperty("lastName") && cur.lastName) {
          payload.lastName = cur.lastName;
          _this.name = _this.name + " " + payload.lastName;
        }

        if (cur && cur.hasOwnProperty("organizationName") && cur.organizationName) {
          payload.organizationName = cur.organizationName;
          _this.organization = payload.organizationName;
        } else {
          this.organization = "XY Studio";
        }

        if (cur && cur.hasOwnProperty("profileImage") && cur.profileImage) {
          payload.profileImage = cur.profileImage;
          _this.profileImage = payload.profileImage;
        }
        if (cur && cur.hasOwnProperty("role") && cur.role) {
          payload.role = cur.role;
          _this.role = payload.role;
        }
        _this.$store.commit("setUser", payload);
      });
    } else {
      this.name = "John Smith";
      this.organization = "XY Studio";
    }
    this.loadMenu();
  },
  methods: {
    userSignOut() {
      this.$store.dispatch("userSignOut");
    },

    goTo(type) {
      if (type == "decisiontree") {
        this.$router.push({ name: "mainStoryView" });
      } else if (type == "universal") {
        this.$router.push({
          name: "comingsoon",
          query: { title: "Universal Rule" },
        });
      } else if (type == "overlay") {
        this.$router.push({ name: "comingsoon", query: { title: "Overlay" } });
      } else if (type == "settings") {
        this.$router.push({
          name: "comingsoon",
          query: { title: "Settings (Setup)" },
        });
      } else if (type == "assets") {
        this.$router.push({ name: "comingsoon", query: { title: "Assets" } });
      } else if (type == "conversation") {
        this.$router.push({
          name: "comingsoon",
          query: { title: "Conversation" },
        });
      } else if (type == "moodboard") {
        this.$router.push({
          name: "comingsoon",
          query: { title: "Moodboard" },
        });
      }
    },

    loadMenu: function () {
      $(".navbar .dropdown-item").on("click", function (e) {
        const $el = $(this).children(".dropdown-toggle");
        const $parent = $el.offsetParent(".dropdown-menu");
        $(this).parent("li").toggleClass("open");

        if (!$parent.parent().hasClass("navbar-nav")) {
          if ($parent.hasClass("show")) {
            $parent.removeClass("show");
            $el.next().removeClass("show");
            // $el.next().css({"top": -999, "left": -999});
          } else {
            $parent.parent().find(".show").removeClass("show");
            $parent.addClass("show");
            $el.next().addClass("show");
            // $el.next().css({"top": $el[0].offsetTop, "left": $parent.outerWidth() - 4});
          }
          e.preventDefault();
          e.stopPropagation();
        }
      });

      $(".navbar .dropdown").on("hidden.bs.dropdown", function () {
        $(this).find("li.dropdown").removeClass("show open");
        $(this).find("ul.dropdown-menu").removeClass("show open");
      });
    },
    openSideBar() {
      const sideBar = document.getElementById('sidebar')
      const sideBarSwitch = document.getElementById('sideBarSwitch')
      const switchX = document.getElementById('switch')
      
      if (switchX.checked == true) {
        sideBarSwitch.style.width = '240px';
        document.querySelector('.sidebar-wrapper.sidebar-wrapper-mini').style.width = '260px';
        document.getElementsByClassName('signout-link')[0].style.display = 'flex';
        document.getElementsByClassName('user-info')[0].style.width = 'auto';
        document.getElementsByClassName('user-info')[0].style.opacity = '1';

        for (let i = 0; i < document.getElementsByClassName('nav-menu-text').length; i++) {
          const element = document.getElementsByClassName('nav-menu-text')[i];
          element.style.opacity = '1';
        }

        for (let i = 0; i < document.getElementsByClassName('dropdown-menu').length; i++) {
          const element = document.getElementsByClassName('dropdown-menu')[i];
          element.style.position = 'static';
          element.style.left = '260px';
        }
        
      } else {
        sideBarSwitch.style.width = '60px';
        // document.querySelector('.sidebar-header.signout-link').style.display = 'block';
        document.querySelector('.sidebar-wrapper.sidebar-wrapper-mini').style.width = '80px';
        
        document.getElementsByClassName('signout-link')[0].style.display = 'none';
        document.getElementsByClassName('user-info')[0].style.width = '0';
        document.getElementsByClassName('user-info')[0].style.opacity = '0';

        for (let i = 0; i < document.getElementsByClassName('nav-menu-text').length; i++) {
          const element = document.getElementsByClassName('nav-menu-text')[i];
          element.style.opacity = '0';
        }

        for (let i = 0; i < document.getElementsByClassName('dropdown-menu').length; i++) {
          const element = document.getElementsByClassName('dropdown-menu')[i];
          element.style.position = 'absolute';
          element.style.left = '60px';
        }
      }
      

    }
  },
};
</script>
<style lang='scss' scoped>
.logout {
  .nav-menu-icon {
    i {
      font-size: 18px;
      margin-left: 7px;
    }
  }
}

.sidebar-wrapper .navbar .logout a:hover {
    background: red;
    color: #fff;
}

.toggle-button-cover
{
    display: table-cell;
    position: relative;
    width: 100%;
    margin: 0 10px;
    height: 40px;
    box-sizing: border-box;
}

.button-cover
{
    height: 100%;
    background-color: #fff;
    box-shadow: 0 10px 20px -8px #c5d6d6;
    border-radius: 4px;
}

.button-cover:before
{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #d7e3e3;
    font-size: 12px;
    line-height: 1;
    padding: 5px;
}

.button-cover, .knobs, .layer
{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.button
{
    position: relative;
    width: 60px;
    height: 29px;
    overflow: hidden;
    border: 1px solid #ffffff59;
    margin: 5px 10px;
    transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

.button.r, .button.r .layer
{
    border-radius: 100px;
}

.checkbox
{
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
}

.knobs
{
    z-index: 2;
}

/* Button 3 */
#sideBarSwitch .knobs:before
{
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 20px;
    height: 10px;
    color: #e7ecff;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 9px 4px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

#sideBarSwitch .checkbox:active + .knobs:before
{
    width: 46px;
    border-radius: 100px;
}

#sideBarSwitch .checkbox:checked:active + .knobs:before
{
    margin-left: -26px;
}

#sideBarSwitch .checkbox:checked + .knobs:before
{
    content: '';
    left: calc(100% - 24px);
}


</style>



// WEBPACK FOOTER //
// src/components/profile/sidebar.vue